import ajax from '../../common/services/httpService'

const BASE_URL = 'sla'

/**
 * @returns {Promise<Array<{id: Number, name: String, company_name: String, ...}>>}
 */
async function getSitesWithOpenSLAs() {
  const sites = await ajax.get(`${BASE_URL}/sites-with-open-slas`)
  return sites
}

export default {
  getSitesWithOpenSLAs,
}

